import { createSelector } from 'reselect';

import { DIMENSION_STATES } from '@common/utils/dimension';

export const getActiveDimensions = state => state.internalStore.activeDimensions;
export const isMobileState = state =>
  state.internalStore.activeDimensions.state === DIMENSION_STATES.MOBILE;

export const getWindowState = createSelector(
  getActiveDimensions,
  activeDimensions => activeDimensions.state,
);

export const getSmallDesktopWindowState = createSelector(
  getActiveDimensions,
  activeDimensions => activeDimensions.small_desktop_state,
);

export const getWindowWidth = createSelector(
  getActiveDimensions,
  activeDimensions => activeDimensions.width,
);
